import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Send } from "lucide-react";

const EMPTY = { name: "", email: "", password: "", phone: "", experience: "" };

export default function TdSignupForm() {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register-td", form);
      await login(data.token, data.user);
      toast.success("Director account created — pending approval. We'll text you when you're in!");
      navigate("/profile");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  const input = "w-full bg-pb-elevated border border-pb-border px-3 py-2.5 text-white placeholder-zinc-600 focus:outline-none focus:border-pb-red text-sm";
  const lbl = "block text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 mb-1.5";

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="td-signup-form">
      <div><label className={lbl}>Full Name *</label>
        <input data-testid="td-signup-name" required value={form.name} onChange={set("name")} placeholder="Your name" className={input} /></div>
      <div className="grid grid-cols-2 gap-3">
        <div><label className={lbl}>Email *</label>
          <input data-testid="td-signup-email" required type="email" value={form.email} onChange={set("email")} placeholder="you@email.com" className={input} /></div>
        <div><label className={lbl}>Password *</label>
          <input data-testid="td-signup-password" required type="password" minLength={6} value={form.password} onChange={set("password")} placeholder="6+ characters" className={input} /></div>
        <div><label className={lbl}>Phone *</label>
          <input data-testid="td-signup-phone" required value={form.phone} onChange={set("phone")} placeholder="941-555-0000" className={input} /></div>
        <div><label className={lbl}>Experience</label>
          <input data-testid="td-signup-experience" value={form.experience} onChange={set("experience")} placeholder="e.g. Ran 5 local events" className={input} /></div>
      </div>
      <button type="submit" data-testid="td-signup-submit" disabled={busy}
        className="w-full bg-pb-red text-black font-bold uppercase tracking-widest py-3 hover:bg-[#BEF264] active:scale-[0.98] transition-all disabled:opacity-50 flex items-center justify-center gap-2">
        <Send className="w-4 h-4" /> {busy ? "Creating…" : "Create Director Account"}
      </button>
    </form>
  );
}
